import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { DxFormModule, DxTemplateModule, DxTextBoxModule } from 'devextreme-angular';
import { DxDataGridModule } from 'devextreme-angular/ui/data-grid';
import { DxDropDownBoxModule } from 'devextreme-angular/ui/drop-down-box';
import { DxListModule } from 'devextreme-angular/ui/list';
import {
    DxiColumnModule,
    DxoEditingModule,
    DxoFilterRowModule,
    DxoFormItemModule,
    DxoPagerModule,
    DxoSelectionModule,
} from 'devextreme-angular/ui/nested';
import { DxSwitchModule } from 'devextreme-angular/ui/switch';
import { DxTreeListModule } from 'devextreme-angular/ui/tree-list';

import { ExcelService } from 'app/global-services/excel.export.service';
import { PopupService } from 'app/global-services/popup.service';
import { FinanceService } from 'app/products/bi/services/finance.service';
import { LazyLoadExcelService } from 'app/products/bi/services/lazyload.export.excel';
import { RateControllerService } from 'app/products/rate-controller/services/rate-controller.service';
import * as echarts from 'echarts';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ProgressbarModule } from 'ngx-bootstrap/progressbar';
import { NgxEchartsModule } from 'ngx-echarts';
import { AngularMaterialModule } from '../../material.module';
import { ContainerViewDirective } from '../directives/container-view.directive';
import { NumbersOnlyDirective } from '../directives/numbers-only.directive';
import { DashboardDatacontrolComponent } from './dashboard-datacontrol/dashboard-datacontrol.component';
import { DashboardOptionsComponent } from './dashboard-options/dashboard-options.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { CommentsDialogComponent } from './popup/comments-dialog/comments-dialog.component';
import { SectionCommentsDialogComponent } from './popup/section-comments-dialog/section-comments-dialog.component';
import { SharedConfirmDialogComponent } from './popup/shared-dialogs/shared-confirm-dialog.component';
import { SectionCommentsComponent } from './section-comments/section-comments.component';
@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        DxDropDownBoxModule,
        DxListModule,
        DxTreeListModule,
        DxSwitchModule,
        DxDataGridModule,
        DxTextBoxModule,
        DxFormModule,
        DxiColumnModule,
        DxoSelectionModule,
        DxoEditingModule,
        DxoPagerModule,
        DxoFormItemModule,
        DxoFilterRowModule,
        DxTemplateModule,
        BsDatepickerModule.forRoot(),
        ProgressbarModule.forRoot(),
        BsDatepickerModule.forRoot(),
        AngularMaterialModule,
        FormsModule,
        NgxEchartsModule.forRoot({ echarts }),

        ContainerViewDirective,
        NumbersOnlyDirective,
        DashboardOptionsComponent,
        DashboardDatacontrolComponent,
        DashboardComponent,
        SectionCommentsComponent,
        CommentsDialogComponent,
        SectionCommentsDialogComponent,
        SharedConfirmDialogComponent,
    ],
    exports: [
        // Common exports
        CommonModule,
        //NgxEchartsModule,
        AngularMaterialModule,
        NgbModule,
        // Dx exports
        DxDropDownBoxModule,
        DxListModule,
        DxTreeListModule,
        DxSwitchModule,
        DxDataGridModule,
        DxTextBoxModule,
        DxFormModule,
        DxiColumnModule,
        DxoSelectionModule,
        DxoEditingModule,
        DxoPagerModule,
        DxoFormItemModule,
        DxoFilterRowModule,
        DxTemplateModule,
        // Custom exports
        ContainerViewDirective,
        NumbersOnlyDirective,
        DashboardOptionsComponent,
        DashboardDatacontrolComponent,
        DashboardComponent,
        SectionCommentsComponent,
        CommentsDialogComponent,
        SectionCommentsDialogComponent,
        SharedConfirmDialogComponent,
    ],
    providers: [
        PopupService,
        ExcelService,
        RateControllerService,
        FinanceService,
        LazyLoadExcelService,
    ],
})
export class ComponentModule {
    static forRoot(): ModuleWithProviders<ComponentModule> {
        return {
            ngModule: ComponentModule,
        };
    }
}
